import { Outlet, ScrollRestoration } from "react-router-dom";
import PublicHeader from "./PublicHeader";
import PageFooter from "./PageFooter";
import useAnalytics from "../useAnalytics";

// Shared chrome for every marketing route. Pages render into <Outlet />
// between the sticky header and the footer; the min-height + flex column
// guarantees the footer sits at the bottom on short pages.
//
// The skip link is the first focusable element so keyboard users can
// bypass the sticky header straight to the page content (anchored on
// <main id="main">).
export default function MarketingLayout() {
    useAnalytics();
    return (
        <div
            style={{
                minHeight: "100dvh",
                display: "flex",
                flexDirection: "column",
                background: "var(--gt-bg)",
            }}
        >
            <a className="gt-skip-link" href="#main">
                Skip to content
            </a>
            {/* New pages open at the top; back/forward restores position. */}
            <ScrollRestoration />
            <PublicHeader />
            <main id="main" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                <Outlet />
            </main>
            <PageFooter />
        </div>
    );
}
